/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import IndirectTaxMainDashboard from '../../components/IndirectTaxComp/IndirectTaxMainDashboard';
import styles from './IndirectTaxPage.module.css';
import { saveLogToBackend } from '../../api';

const IndirectTaxPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const history = useHistory();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  // ############# Start new code for user auth ##################
  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const [hasMainPageAccess, setHasMainPageAccess] = useState(true);
  const [accessiblePages, setAccessiblePages] = useState([]);

  const logData = {
    username: localStorage.getItem("preferred_username") || "anonymous",
    page: window.location.pathname,
    method: "PAGE_VISIT",
    url: window.location.href,
    status: "SUCCESS",
    duration: 0,
    timestamp: new Date().toISOString(),
  };

  useEffect(() => {
    saveLogToBackend(logData);
  }, []);


  useEffect(() => {
    if (roles !== null) {
      const PagesData = roles.pages;
      setAccessiblePages(roles.pages);
      if (roles.pages.includes("IDT MainPage")) {
        setHasMainPageAccess(true);
      } else {
        setHasMainPageAccess(false);
      }
    }
  }, [roles]);

  const pageDetails = {
    "GST Returns Filling": {
      title: "GST Returns Filling, Compliance and Penalties",
      path: "/Indirect-Tax/GST-Return-Filing-Compliance-Penalties"
    },
    "Departmental Notices": {
      title: "Departmental Notices",
      path: "/Indirect-Tax/Departmental-Notices"
    }
  };

  const handleTilesClick = (path) => {
    history.push(path);
  }
  // ############# End new code for user auth ##################

  return (
    <div className={styles.container}>
      {!hasMainPageAccess ? (
        <div className="container mt-4">
          <h3 className="mb-4 text-center" style={{ color: "#0067ac" }}>
            You don't have access to the full Indirect Tax Dashboard.
          </h3>
          <div className="row">
            {accessiblePages.map((page) => {
              const details = pageDetails[page];
              if (!details) return null;
              return (
                <div key={page} className="col-md-4 mb-4">
                  <div
                    className="legal-tile-card"
                    onClick={() => handleTilesClick(details.path)}
                  >
                    <div className="legal-tile-body">
                      <h5 className="legal-tile-title">{details.title}</h5>
                      <p className="legal-tile-text">Click to view {details.title}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <IndirectTaxMainDashboard />
      )}
    </div>
  )
}

IndirectTaxPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(IndirectTaxPage);
